import { useEffect, useState } from "react";
import styles from "./BaseList.module.css";
import EditBase from "../../Modals/Edit/EditBase.jsx";
import UnitListItem from "../MilUnitList/UnitListItem.jsx";
import BaseListItem from "./BaseListItem.jsx";
import viewStyles from "./BaseList.module.css";
import { axiosInstance } from "../../Helpers/axiosInstance.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus , faArrowLeft}  from "@fortawesome/free-solid-svg-icons";
import { BACKEND_URL } from "../../Helpers/constants.js";

export default function Editing({ selectedMode }) {
  const [groupingBases, setGroupingBases] = useState([]);
  const [groupingUnits, setGroupingUnits] = useState([])
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentBase, setCurrentBase] = useState(null);
  const [isBaseListShown, setIsBaseListShown] = useState(false);
  const [unitObj, setUnitObj] = useState(null);
  const [unit, setUnit] = useState(null)
  const [base, setBase] = useState(null)
  const [tableModal, setTableModal] = useState(false)
  const [fileType, setFileType] = useState(null)
  const [search, setSearch] = useState("")
  const [corpuses, setCorpuses] = useState([])
  const [battalions, setBattalions] = useState([])
  const [companies, setCompanies] = useState([])
  const [platoons, setPlatoons] = useState([])
  const [bat, setBat] = useState('')
  const [company, setCompany] = useState('')
  const [platoon, setPlatoon] = useState('')
  
 
  useEffect(() => {
      fetchUnits();
  }, []);
  
  useEffect(() => {
      (async() => {
          const res = await axiosInstance.get('admin/corpuses')
          if(res.data.status){
              setCorpuses(res.data.data)
          }
      })()
  }, [])

  const onClose= () => {
    setIsModalOpen(false)
    setCurrentBase(null)
  }

   useEffect(() => {
        setBattalions(unitObj?.unit_battalions || [])
        }, [unit])


    useEffect(() => {
        (async() => {
            const companyList = await axiosInstance.get(`admin/companies/${unitObj?._id}`)
            if(companyList.status){
                setCompanies(companyList.data.data?.filter(el => el.company_battalion.battalion_number === bat.split(" ")[0]))
            }
        })()
    },[battalions, bat])

    
   useEffect(() => {
        (async() => {
            const platoonsList = await axiosInstance.get(`admin/platoons/${unitObj?._id}`)
            if(platoonsList.status){
                setPlatoons(platoonsList.data.data?.filter(el => el.platoon_battalion.battalion_number === bat.split(" ")[0] && el.platoon_company.company_number === company))
            }
        })()
        }, [company, bat])

  const fetchUnits = async () => {
    try {
      const response = await axiosInstance.get('admin/milunits');
      setGroupingUnits(response.data.data);
      setIsBaseListShown(false);
    } catch (error) {
      console.error("Error fetching units:", error);
    }
  };
  
  const fetchBases = async (unit_number) => {
    if (!unit_number) return; 
    try {
      let unitNumber = unit_number
      if(unit_number.startsWith("#")){unitNumber = unit_number.replace('#','t')}
      const response = await axiosInstance.get(`/admin/bases-from-unit/${unitNumber}`);
      setGroupingBases(response.data.data);
    } catch (error) {
      console.error("Error fetching bases:", error);
    }
  };

  const fetchBase = async (base_id) => {
    if (!base_id) return; 
    try {
      let baseik = base_id
      const response = await axiosInstance.get(`/admin/base/${baseik}`);
      setCurrentBase(response.data.data);
    } catch (error) {
      console.error("Error fetching bases:", error);
    }
  };

  const getUnitExcel = async () => {
      const res = await axiosInstance.get(`/admin/bases-excel/${unitObj._id}?battalion=${bat}&company=${company}&platoon=${platoon}`)
      const { filePath } = res.data.data;

      const downloadLink = document.createElement("a");
      downloadLink.href = BACKEND_URL + filePath;
      downloadLink.download = "data.xlsx";
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
  }

  const getUnitExcelCount = async () => {
    const res = await axiosInstance.get(`/admin/bases-excel-count/${unitObj._id}?battalion=${bat}&company=${company}&platoon=${platoon}`)
    const { filePath } = res.data.data;

    const downloadLink = document.createElement("a");
    downloadLink.href = BACKEND_URL + filePath;
    downloadLink.download = "data.xlsx";
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
}

  const getUnitWord =  async () => {
      const res = await axiosInstance.get(`/admin/bases-word/${unitObj._id}?battalion=${bat}&company=${company}&platoon=${platoon}`)
      const { filePath } = res.data.data;

      const downloadLink = document.createElement("a");
      downloadLink.href = BACKEND_URL + filePath;
      downloadLink.download = "data.xlsx";
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
  }


  const getUnitExcelCountPerson = async () => {
    const res = await axiosInstance.get(`/admin/bases-excel-count-people/${unitObj._id}?battalion=${bat}&company=${company}&platoon=${platoon}`)
    const { filePath } = res.data.data;

    const downloadLink = document.createElement("a");
    downloadLink.href = BACKEND_URL + filePath;
    downloadLink.download = "data.xlsx";
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
}


  const getCountReport = async () => {
    const res = await axiosInstance.get(`/admin/countReport?unit=${unitObj.unit_number}&battalion=${bat}&company=${company}&platoon=${platoon}`)
    const { filePath } = res.data.data;

    const downloadLink = document.createElement("a");
    downloadLink.href = BACKEND_URL + filePath;
    downloadLink.download = "data.xlsx";
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
}

  const handleBack = () => {
  setIsBaseListShown(false);
  setBase(null);
  setCurrentBase(null);
  setGroupingBases([]); 
};


  return (
    <div className={styles["editing-list-conteiner"]} onClick={() => {setFileType(null); setTableModal(false)}}>
    <div className={styles["editing-list"]}>
      {isBaseListShown && (
        <div className={styles["back-btn"]} onClick={handleBack}>
            <FontAwesomeIcon icon={faArrowLeft} />
        </div>
      
      )}
      {!isBaseListShown && <input type="text" placeholder="Որոնել" className={styles["search-input"]} style={{marginTop: "20px"}} value={search} onChange={(e) => setSearch(e.target.value)}/>}
      <div className={styles["header-row"]}>
  <div>
  <h2>{!isBaseListShown ? 'Ընտրել զորամասը' : 'Հենակետեր'}</h2>
 </div>
 </div>

      {isBaseListShown && <div className={styles['base-list-header']}>
              <FontAwesomeIcon icon={faPlus} className={styles['adding']} onClick={() => setIsModalOpen(true)} title="Ավելացնել հենակետ"/>
      </div>}
      {isBaseListShown && (<div>
        <div className={styles["count-option"]}>
          <div className={styles["selects-div"]}>
            <div className={styles["each-option"]} >
              <p>Գումարտակի </p>
              <select onChange={(e) => {setBat(e.target.value); setCompany(''); setPlatoon('')}}>
                <option value="">--</option>
                {battalions?.map(el => (<option key={el._id} value={el.battalion_number + " " + el.battalion_name}>{el.battalion_number}</option>))}
              </select>
            </div>
            <div className={styles["each-option"]}>
              <p>ՀՎ-ի</p>
              <select onChange={(e) => {setCompany(e.target.value); setPlatoon('')}} value={company}>
                <option value="">--</option>
                {companies?.map((el, i) => (<option key={el._id} value={el.company_number}>{el.company_number}</option>))}
              </select>
            </div>
            <div className={styles["each-option"]}>
              <p> ՀՎ հդ</p>
              <select onChange={(e) => setPlatoon(e.target.value)} value={platoon}>
                <option value="">--</option>
                {platoons?.map(el => (<option key={el._id} value={el.platoon_number}>{el.platoon_number}</option>))}
              </select>
            </div>
          </div>
        </div>
      </div>)}
      {!isBaseListShown ? (
        <div className={styles["unit-list-container"]}>
          { !!groupingUnits?.filter(el => (el.unit_number.includes(search) || el.unit_close_number.includes(search)) && el.unit_corpus === "").length && <div>
              <h4>ՀԲԿ</h4>
              {
                 groupingUnits?.filter(el => (el.unit_number.includes(search) || el.unit_close_number.includes(search)) && el.unit_corpus === "").map((item, index) => (
                  <UnitListItem
                      key={index}
                      item={item}
                      index={index}
                      onClick={() => {fetchBases(item.unit_number);setUnitObj(item); setUnit(item.unit_number); setIsBaseListShown(true); if(selectedMode === "Մուտքագրում"){setCurrentBase(null)}}}
                  />
                  )
                )
              }
            </div>
          }
          {
            corpuses?.map((corpus, index) => 
              groupingUnits.filter(el => (el.unit_number.includes(search) || el.unit_close_number.includes(search)) && el.unit_corpus === corpus._id).length ? (
              <div className={styles["unit-list-container"]} key={index}>
                <h4>{corpus.corpus_number} {corpus.corpus_name}</h4>
                {
                     groupingUnits.filter(el => (el.unit_number.includes(search) || el.unit_close_number.includes(search)) && el.unit_corpus === corpus._id).map((item, index) => (
                      <UnitListItem
                          key={index}
                          item={item}
                          index={index}
                          onClick={() => {fetchBases(item.unit_number);setUnitObj(item); setUnit(item.unit_number); setIsBaseListShown(true); if(selectedMode === "Մուտքագրում"){setCurrentBase(null)}}}
                      />
                     )
                    )
                }
              </div>
            ) : ""
          )
          }
        </div>
      )
          :
          isBaseListShown 
          ? 
          <>          
          {groupingBases?.map((item, index) => (
            <BaseListItem
              key={index}
              item={item}
              index={index}
              fetchBase={fetchBase}
              setIsModalOpen={setIsModalOpen}
              setGroupingBases={setGroupingBases}
              unit={unit}
              unitObj={unitObj}
              setBase={setBase}
              base={base}
              
             />
            
          ))
        }
          </>
       : (
        <p>Loading data...</p>
      )}
      </div>
      {isModalOpen ? (
        <EditBase 
         onClose={onClose}
         data={currentBase}
         setGroupingBases={setGroupingBases}
         unit={unit}
         unitId={unitObj._id}
      />
      ) : ''}
      {unit && <div className={viewStyles["all-convertsion"]} onClick={(e) => e.stopPropagation()} onMouseEnter={() => setTableModal(true)} onMouseLeave={() => setTableModal(false)}>
        <img src="/word.png" alt="word" title="Ստանալ ֆայլ զորամասի բոլոր հենակետերի համար"  onMouseEnter={() => {setFileType("word")}} onClick={() => {setFileType("word"); setTableModal(true)}}/>
        <img src="/excel.png" alt="excel" title="Ստանալ ֆայլ զորամասի բոլոր հենակետերի համար" onMouseEnter={() => {setFileType("excel")}} onClick={() => {setFileType("word"); setTableModal(true)}}/>
      {tableModal && <div className={styles["table-modal"]} onMouseEnter={(e) => e.stopPropagation()}>
          <p onClick={() => {fileType === "word" ? getUnitWord() : getUnitExcel(); setTableModal(false); setFileType(null)}}>Անձնակազմ</p>
          <p onClick={getUnitExcelCountPerson}>Քանակական կազմ (Անձնակազմ)</p>
          <p onClick={getUnitExcelCount}>Քանակական կազմ (Սպառազինություն)</p>
          <p onClick={getCountReport}>Մարտական քանակական կազմ </p>
        </div>}
      </div>}
    </div>
  );
}